module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro-heading02-sp-de989ac483c71a40a649c6cfccf649fb.png";